/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Financials_Range_Dropdown_DescriptionInputs */



/**
* | output |
* | --- |
* | "For on-chain revenue & average transaction fee" |
*
* @param {Financials_Range_Dropdown_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const financials_range_dropdown_description = /** @type {((inputs?: Financials_Range_Dropdown_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Financials_Range_Dropdown_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("For on-chain revenue & average transaction fee")
});